<template>
  <div class="homepage-grid">
    <div class="hero">
      <AW23Hero
        :video-url="heroVideoURL"
        title="FLASH SALE"
        desktop-title="FLASH SALE"
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/ezgif-frame-001_1_4bd96c29-a258-4034-b3fb-efb9500de08f.jpg?v=1708528955',
          smallMedia2x:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/ezgif-frame-001_1_4bd96c29-a258-4034-b3fb-efb9500de08f.jpg?v=1708528955',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/ezgif-frame-001_1_4bd96c29-a258-4034-b3fb-efb9500de08f.jpg?v=1708528955',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/ezgif-frame-001_588c5c4d-4e27-40a1-916f-bed9ee840e80.jpg?v=1708528864',
        }"
        :low-power-images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/RAT_BOA_18_1_1.jpg?v=1707739963',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/RAT_BOA_18_1_1.jpg?v=1707739963',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_1_2_1.jpg?v=1707479608',
        }"
      >
        <template #cta>
          <Button transparent tag="a" href="/collections/all">
            UP TO 70% OFF
          </Button>
        </template>
      </AW23Hero>
    </div>
    <div class="dresses">
      <AW23Category
        text="SHOP NOW"
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_2_2_1_d6b97f55-9cbc-4060-b976-b6947d75897e.jpg?v=1708527897',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_2_2_1_d6b97f55-9cbc-4060-b976-b6947d75897e.jpg?v=1708527897',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_2_2_1_d6b97f55-9cbc-4060-b976-b6947d75897e.jpg?v=1708527897',
        }"
        link="/collections/dresses"
      >
        <template #cta>
          <Button transparent tag="a" href="/collections/dresses">
            Dresses
          </Button>
        </template>
      </AW23Category>
    </div>
    <div class="beachwear">
      <AW23Category
        text="SHOP NOW"
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_7_1_1_ab8d7c41-e7b5-436a-9e1d-f79aa9d73d67.jpg?v=1708527905',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_7_1_1_ab8d7c41-e7b5-436a-9e1d-f79aa9d73d67.jpg?v=1708527905',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_7_1_1_ab8d7c41-e7b5-436a-9e1d-f79aa9d73d67.jpg?v=1708527905',
        }"
        link="/collections/beachwear"
      >
        <template #cta>
          <Button transparent tag="a" href="/collections/beachwear">
            beachwear
          </Button>
        </template>
      </AW23Category>
    </div>
    <div class="carousel">
      <FeaturedProductsCarousel
        v-if="nostoProductRecommendations"
        :product-ids="nostoProductRecommendations"
        :nosto-placement="nostoProductRecommendationsProductId"
        flat-lays
      />
    </div>
    <div class="loyalty">
      <AW23TextCard
        title="MEMBERS ONLY"
        text="Sign up to our Members Only club for early access to new collections, bespoke rewards and exclusive offers. Join now and we’ll give you a £20 to spend on your first order."
      >
        <template #cta>
          <Button @click="setSlideLogin(true)">My Account</Button>
          <Button @click="setSlideSignUp(true)">Create Account</Button>
        </template>
      </AW23TextCard>
    </div>
    <div class="carousel2">
      <FeaturedProductsCarousel collection-handle="spring-fever" flat-lays />
    </div>
    <div class="journal">
      <AW23Category
        link="/blogs/journal"
        :images="{
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_9_1_77c22551-0e24-4074-87f4-cb6f0347d9fa.jpg?v=1708529230',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_9_1_77c22551-0e24-4074-87f4-cb6f0347d9fa.jpg?v=1708529230',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_8_3_1_1.jpg?v=1708526882',
        }"
      >
        <template #cta>
          <Button transparent tag="a" href="/blogs/journal">
            THE JOURNAL
          </Button>
        </template>
      </AW23Category>
    </div>
    <div class="journal-text">
      <AW23TextCard
        text="Places, faces and behind-the-scenes insight into our world. A curated collection of visual essays, travel diaries and style inspiration direct from the Rat and Boa studio."
      >
        <template #cta>
          <Button tag="a" href="/blogs/journal"> READ OUR STORIES </Button>
        </template>
      </AW23TextCard>
    </div>
  </div>

  <DataCollectionTrigger />
</template>

<script>
import { mapGetters } from "vuex";
import AW23Hero from "@/components/homepage/AW23Hero.vue";
import AW23Category from "@/components/homepage/AW23Category.vue";
import AW23TextCard from "@/components/homepage/AW23TextCard.vue";
import FeaturedProductsCarousel from "@/components/FeaturedProductsCarousel.vue";
import Button from "@/components/Button.vue";
import { getFeatureToggles } from "@/helpers/featureToggles.js";
import { mapActions } from "vuex";
import DataCollectionTrigger from "@/components/DataCollectionTrigger.vue";

export default {
  name: "HomePage",
  components: {
    AW23Hero,
    AW23Category,
    AW23TextCard,
    FeaturedProductsCarousel,
    Button,
    DataCollectionTrigger,
  },
  inject: ["mq"],
  data() {
    return {
      nostoProductRecommendations: null,
      nostoProductRecommendationsProductId: null,
      heroVideoURL: null,
    };
  },
  computed: {
    ...mapGetters("app", ["homepageViewed"]),
    showStory() {
      const { showStory = false } = getFeatureToggles();
      return showStory;
    },
  },
  created() {
    // eslint-disable-next-line no-undef
    nostojs((api) => {
      api
        .defaultSession()
        .viewFrontPage()
        .setPlacements(["frontpage-nosto-1"])
        .load()
        .then((data) => {
          this.nostoProductRecommendations =
            data.recommendations["frontpage-nosto-1"]?.products || null;
          this.nostoProductRecommendationsProductId =
            data.recommendations["frontpage-nosto-1"]?.result_id || null;
        });
    });
  },
  mounted() {
    this.heroVideoURL = this.setVideoUrl();
  },
  methods: {
    ...mapActions("app", ["setSlideLogin", "setSlideSignUp"]),
    setVideoUrl() {
      const desktopVideoUrl =
        "https://cdn.shopify.com/videos/c/o/v/ac9249746245418e8d1df50eb0274765.mp4";
      const mobileVideoUrl =
        "https://cdn.shopify.com/videos/c/o/v/79816fb6b5684ba69414cd3fe7950aaa.mp4";

      if (this.mq.mdPlus) {
        return desktopVideoUrl;
      }

      return mobileVideoUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.homepage-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  grid-template-areas:
    "hero"
    "carousel"
    "dresses"
    "loyalty"
    "beachwear"
    "carousel2"
    "journal"
    "journal-text";

  @include respond-above(md) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      "hero hero"
      "carousel carousel"
      "dresses beachwear"
      "loyalty loyalty"
      "journal journal"
      "journal-text journal-text"
      "carousel2 carousel2";
  }

  .hero {
    grid-area: hero;
  }

  .hero-text {
    @include t__editorial-headline-30;
    text-decoration: none;
    margin: 0 0 5px 0;
    padding: 0;
    @include respond-above(md) {
      @include t__editorial-headline-80;
    }
  }

  .dresses {
    grid-area: dresses;
  }

  .beachwear {
    grid-area: beachwear;
    @include respond-above(md) {
      height: 90vh;
      overflow: hidden;
    }
  }

  .carousel {
    grid-area: carousel;
    ::v-deep(.photos) {
      gap: 0;
    }
    ::v-deep(.photos > *) {
      margin-right: 0;
    }
  }

  .carousel2 {
    grid-area: carousel2;
    ::v-deep(.photos) {
      gap: 0;
    }
    ::v-deep(.photos > *) {
      margin-right: 0;
    }
  }

  .loyalty {
    grid-area: loyalty;
  }

  .journal {
    grid-area: journal;
  }

  .journal-text {
    grid-area: journal-text;
  }
}
</style>
